import {SidebarComponent}  from "./sidebar.component";

export const SidebarModule = angular
	.module("sidebar", [])
	.component("sidebar", SidebarComponent);


// WEBPACK FOOTER //
// ./sources/components/layout/sidebar/sidebar.js